import styles from "../../pages/product/product.module.scss";
import {useEffect, useState} from "react";

export const Stars = (props: {
    score: number
}) => {

    const [starsClass, setStartsClass] = useState<string[]>([]);

    useEffect(() => {
        const classes = [];
        const roundToHalf = Math.round(props.score * 2) / 2.0;
        let tmpScore = roundToHalf;

        while (tmpScore >= 1) {
            classes.push("star-yes");
            tmpScore--;
        }

        while (tmpScore >= 0.5) {
            classes.push("star-yes-half");
            tmpScore = tmpScore - 0.5;
        }

        tmpScore = roundToHalf;
        while (tmpScore <= 4) {
            classes.push("star-no");
            tmpScore++;
        }

        setStartsClass(classes);
    }, [props.score])

    return (
        <div className={styles["comment-stars"]}>
            {
                starsClass.map((starClass, idx) => {
                    if (starClass === "star-yes") {
                        return (
                            <div className={styles["star-yes"]} key={idx}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10"
                                     viewBox="0 0 11 10">
                                    <path className={styles["ic-star-yes-a"]}
                                          d="M7.5,2,9.2,5.291l3.8.531-2.75,2.56L10.9,12,7.5,10.291,4.1,12,4.75,8.383,2,5.822l3.8-.531Z"
                                          transform="translate(-2 -2)"/>
                                </svg>
                            </div>
                        )
                    }
                    if (starClass === "star-yes-half") {
                        return (
                            <div className={styles["star-yes-half"]} key={idx}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="7.517" height="6.833"
                                     viewBox="0 0 7.517 6.833">
                                    <path className={styles["ic-star-no-a"]}
                                          d="M5.758,2,6.92,4.249l2.6.363L7.638,6.362l.443,2.472L5.758,7.666,3.436,8.833l.443-2.472L2,4.612l2.6-.363Z"
                                          transform="translate(-2 -2)"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="5.5" height="10"
                                     viewBox="0 0 5.5 10">
                                    <path className={styles["ic-star-yes-a"]}
                                          d="M7.5,2v8.291L4.1,12,4.75,8.383,2,5.822l3.8-.531"
                                          transform="translate(-2 -2)"/>
                                </svg>
                            </div>
                        )
                    }
                    if (starClass === "star-no") {
                        return (
                            <div className={styles["star-no"]} key={idx}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="7.517" height="6.833"
                                     viewBox="0 0 7.517 6.833">
                                    <path className={styles["ic-star-no-a"]}
                                          d="M5.758,2,6.92,4.249l2.6.363L7.638,6.362l.443,2.472L5.758,7.666,3.436,8.833l.443-2.472L2,4.612l2.6-.363Z"
                                          transform="translate(-2 -2)"/>
                                </svg>
                            </div>
                        )
                    }

                })
            }
        </div>
    )
}
